export default __webpack_public_path__ + "static/hand-e5adab8a603fa6f3701988afcc2822ba.png";